export const DealsPageFooter = ({ children }: { children: React.ReactNode }) => (
    <footer className="flex w-full shrink-0 gap-3">{children}</footer>
);
